<template></template>

<script>
import moment from "moment";
import { isMinStatus, newTerminalInfo } from "./util.js";
import { nanoid } from "nanoid";
import axios from "axios";
export default {
    name: "sendMetrics",
    components: {},
    props: ["userID", "channel", "targetUrl"],
    data() {
        return {
            interval: null,
            timeout:null
        };
    },
    mounted() {
        this.loadPage()
    },
    destroyed() {
        document.removeEventListener("click", this.setClickTime);
    },
    methods: {
        loadPage() {
            if (!sessionStorage.getItem("sessionId")) {
                sessionStorage.setItem("sessionId", nanoid());
            }
            const time = moment().format("YYYY-MM-DD HH:mm:ss");
            window.localStorage.setItem("beforeTime", time);
            document.addEventListener("click", this.setClickTime);
            this.sendTime();
            this.timeout = setTimeout(() => {
                const loadTime = window.performance.timing.loadEventEnd - window.performance.timing.fetchStart;
                const referrer = document.referrer ? document.referrer : (sessionStorage.getItem('preUrl') || '直接访问');
                const obj = {
                    userId: this.userID || "guest",
                    cookieId: sessionStorage.getItem("sessionId"),
                    clientType: newTerminalInfo(),
                    lang: localStorage.getItem("locale") || "en-US",
                    url: window.location.href,
                    preUrl: referrer,
                    eventType: "loadTime",
                    channel: this.channel,
                    utlogMap: `{loading_time: ${loadTime}}`,
                    uuid: window.navigator.userAgent.replace(/[^\w]/gi, ''),//当前电脑浏览器的唯一标识
                    env: (process.env.NODE_ENV == 'production') ? 'prod' : 'dev'
                };
                let api_key = localStorage.getItem("api-key");
                axios({
                    method: "POST",
                    url: this.targetUrl,
                    data: obj,
                    headers: {
                        "Content-Type": "application/json",
                        'Dde-Ananlytics-Utlog-Api-Key': api_key,
                    },
                });
            }, 20000);
        },
        setClickTime() {
            const time = moment().format("YYYY-MM-DD HH:mm:ss");
            window.localStorage.setItem("beforeTime", time);
        },
        sendTime() {
            this.interval = setInterval(() => {
                this.visitTime()
            }, 60000);
        },
        visitTime() {
            if (isMinStatus()) {
                console.log("是最小化", isMinStatus());
            } else {
                const beforeTime = window.localStorage.getItem("beforeTime");
                const time = moment().format("YYYY-MM-DD HH:mm:ss");
                const timeDiff = moment(time).diff(beforeTime, "minute");
                if (timeDiff > 20) {
                    return;
                }
                let api_key = localStorage.getItem("api-key");
                const referrer = document.referrer ? document.referrer : (sessionStorage.getItem('preUrl') || '直接访问');
                //发送
                axios({
                    method: "POST",
                    url: this.targetUrl,
                    data: {
                        url: window.location.href,
                        userId: this.userID || "guest",
                        cookieId: sessionStorage.getItem("sessionId"),
                        clientType: newTerminalInfo(),
                        lang: localStorage.getItem("locale") || "en-US",
                        preUrl: referrer,
                        eventType: "visitTime",
                        channel: this.channel,
                        uuid: window.navigator.userAgent.replace(/[^\w]/gi, ''),//当前电脑浏览器的唯一标识
                        env: (process.env.NODE_ENV == 'production') ? 'prod' : 'dev'
                    },
                    headers: {
                        "Content-Type": "application/json",
                        'Dde-Ananlytics-Utlog-Api-Key': api_key
                    },
                });
            }
        },
        clearInterval() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
            if(this.timeout){
                clearTimeout(this.timeout)
                this.timeout = null;
            }
        },
    },
    watch: {
        $route: function (value, oldValue) {
            if (value.name != oldValue.name && (oldValue.name != null)) {
                this.clearInterval();
                this.loadPage()
            }
        }
    }
};
</script>
